import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

type ContainerProps = {
  ['data-banner-height']?: number
  ['data-content-padding']?: number
}

export const StyledContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${(props: ContainerProps) => props?.['data-banner-height']}px;
  margin-bottom: 32px;
  background-color: #142340;
  .animation-image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-top: auto;
    margin-right: auto;
    margin-bottom: auto;
    margin-left: auto;
    opacity: 0;
  }
  ${MediaQueries.mbDown} {
    z-index: 100;
    .animation-image {
      width: 100%;
      height: auto;
    }
  }

  ${MediaQueries.mbUp} {
    z-index: 11;
    .animation-image {
      width: auto;
      height: ${(props: ContainerProps) => props?.['data-banner-height']}px;
    }
  }
`
export const StyledDataContainer = styled.div`
  position: absolute;
  ${MediaQueries.mbDown} {
    bottom: 30px;
    left: 16px;
  }

  ${MediaQueries.mbUp} {
    top: 35%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  }
  .country-title {
    color: #ffca49;
    font-family: 'Inter';
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    opacity: 0;
  }
`

export const StyledDataWrapper = styled.div`
  margin-bottom: 14px;
  .data-label {
    color: #d1d3d4;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
  }
  .progress-bar {
    display: flex;
    align-items: center;
    .data-value {
      display: inline-block;
      margin-left: 13px;
      color: #d1d3d4;
      font-family: Inter;
      font-size: 24px;
      font-style: normal;
      font-weight: bold;
      line-height: 36px;
      .value-number {
        display: inline-block;
      }
    }
  }
`

export const StyledDotsContainer = styled.div`
  position: absolute;
  ${MediaQueries.mbDown} {
    bottom: 20px;
  }
  ${MediaQueries.mbUp} {
    bottom: 24px;
  }
  left: 50%;
  display: flex;
  transform: translateX(-50%);
`
export const StyledDot = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  background-color: ${theme.colors.yellow50};
  border-radius: 50%;
  cursor: pointer;
  &[data-active='true'] {
    background-color: ${theme.colors.yellow800};
  }
`

export const StyledPreviousMap = styled.div`
  position: absolute;
  top: 50%;
  left: 3%;
  flex-direction: column;
  transform: translateY(-50%);
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`

export const StyledNextMap = styled.div`
  position: absolute;
  top: 50%;
  right: 3%;
  flex-direction: column;
  transform: translateY(-50%);
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`
